import styles from './InlineAlert.module.css'

interface InlineAlertProps {
  message: string
  variant?: 'success' | 'error' | 'info' | 'warning'
  onDismiss?: () => void
}

export default function InlineAlert({ message, variant = 'info', onDismiss }: InlineAlertProps) {
  return (
    <div className={`${styles.alert} ${styles[variant]}`} data-testid="inline-alert">
      <span className={styles.message}>{message}</span>
      {onDismiss && (
        <button className={styles.dismiss} onClick={onDismiss} data-testid="inline-alert-dismiss">
          &times;
        </button>
      )}
    </div>
  )
}
